import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import MuiTextField from '@material-ui/core/TextField';
import pickMuiTextFieldProps from '../utils/pickMuiTextFieldProps';
import fieldErrorAndHelperText from '../utils/fieldErrorAndHelperText';
/**
 * Slouží jako TextField pro zobrazení hodnoty s možností případné onClick/onChange func ...
 */

var TextField = React.forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
      error = _ref.error,
      helperText = _ref.helperText,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value,
      textFieldProps = _objectWithoutProperties(_ref, ["autoComplete", "error", "helperText", "label", "onChange", "value"]);

  var handleChange = function handleChange(event) {
    var _ref2 = (event || {}).target || {},
        nextValue = _ref2.value;

    if (onChange) {
      onChange(nextValue);
    }
  };

  var autoCompleteValue = typeof autoComplete === 'undefined' ? 'off' : autoComplete;

  var _fieldErrorAndHelperT = fieldErrorAndHelperText({
    error: error,
    helperText: helperText,
    label: label
  }),
      _fieldErrorAndHelperT2 = _slicedToArray(_fieldErrorAndHelperT, 2),
      isError = _fieldErrorAndHelperT2[0],
      helperTextOrErrorMessage = _fieldErrorAndHelperT2[1];

  var innerProps = pickMuiTextFieldProps(_extends({}, textFieldProps, {
    label: label,
    error: isError,
    helperText: helperTextOrErrorMessage,
    autoComplete: autoCompleteValue,
    value: value || '',
    onChange: handleChange
  }));
  return /*#__PURE__*/React.createElement(MuiTextField, _extends({}, innerProps, {
    inputRef: ref
  }));
});
TextField.displayName = 'TextField';
TextField.propTypes = {
  /**
   * This property helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill. You can learn more about it here:
   * https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill
   */
  autoComplete: PropTypes.string,

  /**
   * `true` ak ma mat pole focus po prvom mounte.
   */
  autoFocus: PropTypes.bool,

  /**
   * Jmeno CSS tridy.
   */
  className: PropTypes.string,

  /**
   * Defaultni hodnota.
   */
  defaultValue: PropTypes.string,

  /**
   * `true` pokud ma byt field disablovan.
   */
  disabled: PropTypes.bool,

  /**
   * Chybova hlaska.
   */
  error: PropTypes.string,

  /**
   * Pokud je `true` bude se renderovat polozka na plnou dostupnou sirku.
   */
  fullWidth: PropTypes.bool,

  /**
   * Pomocny text, zobrazovany pod `input`em.
   */
  helperText: PropTypes.string,

  /**
   * Hodnota atributu `id` nativniho `input`u.
   */
  id: PropTypes.string,

  /**
   * `Object` s custom vlastnostmi komponenty `InputLabel`.
   */
  InputLabelProps: PropTypes.shape({}),

  /**
   * `Object` s custom vlastnostmi komponenty `Input`.
   */
  InputProps: PropTypes.shape({}),

  /**
   * `Object` s custom vlastnostmi komponenty `input` (nativni).
   */
  inputProps: PropTypes.shape({}),

  /**
   * Zobrazovany label.
   */
  label: PropTypes.string,

  /**
   * Margin fieldu.
   */
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * Pokud je `true` hodnota je viceradkova
   */
  multiline: PropTypes.bool,

  /**
   * Hodnota atributu `name` nativniho `input`u.
   */
  name: PropTypes.string,

  /**
   * Handler pro obsluhu zmeny.
   *
   * Signatura funkce: `(value: TValue) => void`
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Hodnota zobrazovana, pokud je `value` prazdne / nedefinovane.
   */
  placeholder: PropTypes.string,

  /**
   * `true` pokud ma byt field vyzadovan. Pokud je `true`, automaticky se do labelu prida '*'.
   */
  required: PropTypes.bool,

  /**
   * Inicialni pocet radku u multiline.
   */
  rows: PropTypes.number,

  /**
   * Maximalni pocet radku u multiline.
   */
  rowsMax: PropTypes.number,

  /**
   * Objekt stylu.
   */
  style: PropTypes.shape({}),

  /**
   * Hodnota atributu `type` nativniho `input`u.
   */
  type: PropTypes.string,

  /**
   * Hodnota fieldu (`TValue`).
   */
  value: PropTypes.string
};
TextField.defaultProps = {
  autoComplete: undefined,
  autoFocus: undefined,
  className: undefined,
  defaultValue: undefined,
  disabled: undefined,
  error: undefined,
  fullWidth: undefined,
  helperText: undefined,
  id: undefined,
  InputLabelProps: undefined,
  InputProps: undefined,
  inputProps: undefined,
  label: undefined,
  margin: 'dense',
  multiline: false,
  name: undefined,
  placeholder: undefined,
  required: undefined,
  rows: undefined,
  rowsMax: undefined,
  style: undefined,
  type: undefined,
  value: undefined
};
export default TextField;